import { render, staticRenderFns } from "./leftTreeRightTable.vue?vue&type=template&id=50b084f0&scoped=true&"
import script from "./leftTreeRightTable.vue?vue&type=script&lang=js&"
export * from "./leftTreeRightTable.vue?vue&type=script&lang=js&"
import style0 from "./leftTreeRightTable.vue?vue&type=style&index=0&id=50b084f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b084f0",
  null
  
)

export default component.exports